import axios from "axios";

const api = axios.create({
  baseURL: "https://157.245.99.9/api/auth", // backend base URL
});

// Attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auto-refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          const res = await axios.post(
            "https://157.245.99.9/api/auth/token/refresh/",
            { refresh: refreshToken }
          );

          localStorage.setItem("accessToken", res.data.access);
          originalRequest.headers.Authorization = `Bearer ${res.data.access}`;
          return api(originalRequest);
        }
      } catch (err) {
        console.error("Token refresh failed:", err);
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

// -------------------
// 🎁 Gift APIs
// -------------------
export const getGifts = () => api.get("/admin/gift-earn/");
export const addGift = (gift) => api.post("/admin/gift-earn/", gift);
export const updateGift = (id, gift) => api.put(`/admin/gift-earn/${id}/`, gift);
export const deleteGift = (id) => api.delete(`/admin/gift-earn/${id}/`);

// -------------------
// 🔔 Notification APIs
// -------------------
export const getNotificationsApi = () => api.get("/admin/notifications/");
export const markNotificationRead = (id) =>
  api.post(`/admin/notifications/${id}/`);

export default api;
